(() => {
  const LIFESTYLE_IMAGE = 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/peakstyle-activity-lifestyle.png?v=1785719473';
  const RUN_IMAGE = 'https://cdn.shopify.com/s/files/1/0621/0060/2968/files/peakstyle-activity-laufsport.png?v=1785719485';

  function replaceResponsiveImage(container, url, alt) {
    if (!container) return;
    container.querySelectorAll('source').forEach((source) => {
      source.srcset = url;
      source.removeAttribute('data-srcset');
    });
    container.querySelectorAll('img').forEach((img) => {
      img.src = url;
      img.srcset = url;
      img.alt = alt;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('loading');
    });
  }

  function removeNumbering(tabs) {
    tabs.querySelectorAll('.collapsible__button-icon').forEach((number) => {
      number.setAttribute('aria-hidden', 'true');
      number.textContent = '';
    });
  }

  function apply() {
    const section = document.getElementById('activities');
    const tabs = section?.querySelector('collection-tabs');
    if (!tabs) return;

    const contentItems = [...tabs.querySelectorAll('.f-collection-tab__content-wrap > motion-element')];
    const runContent = contentItems.find((item) =>
      item.querySelector('.collapsible__button-text')?.textContent.trim().toLowerCase() === 'laufsport'
    );
    const runTab = runContent?.querySelector('collapsible-tab');
    const runId = runTab?.dataset.blockId;
    const runImage = runId
      ? tabs.querySelector(`.f-collection-tab__image[data-block-id="${CSS.escape(runId)}"]`)
      : null;

    replaceResponsiveImage(runImage, RUN_IMAGE, 'Trailrunner beim Laufsport vor alpiner Bergkulisse');

    const lifestyleExists = contentItems.some((item) =>
      item.querySelector('.collapsible__button-text')?.textContent.trim().toLowerCase() === 'lifestyle'
    );

    if (!lifestyleExists && runContent && runImage) {
      const lifestyleId = 'peakstyle-lifestyle';
      const lifestyleImage = runImage.cloneNode(true);
      lifestyleImage.dataset.blockId = lifestyleId;
      lifestyleImage.classList.remove('is-active');
      replaceResponsiveImage(lifestyleImage, LIFESTYLE_IMAGE, 'Lifestyle Outdoorbekleidung am Wasser vor Bergkulisse');
      runImage.before(lifestyleImage);

      const lifestyleContent = runContent.cloneNode(true);
      const lifestyleTab = lifestyleContent.querySelector('collapsible-tab');
      if (lifestyleTab) {
        lifestyleTab.dataset.blockId = lifestyleId;
        lifestyleTab.removeAttribute('open');
        lifestyleTab.classList.remove('is-open', 'is-expanded', 'is-selected');
      }
      const heading = lifestyleContent.querySelector('.collapsible__button-text');
      if (heading) heading.textContent = 'Lifestyle';
      const description = lifestyleContent.querySelector('.collapsible__content-inner');
      if (description) description.innerHTML = '<p>Outdoor-inspirierte Styles für Alltag, Reise und Freizeit.</p>';
      const link = lifestyleContent.querySelector('.collection-tab__link');
      if (link) {
        link.href = '/collections/activity-urban_outdoor';
        link.setAttribute('aria-label', 'Lifestyle');
      }
      runContent.before(lifestyleContent);
    }

    removeNumbering(tabs);
    tabs.dataset.peakstyleActivityImagesApplied = 'true';
    if (typeof tabs.init === 'function') tabs.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:block:select', apply);
})();
